module.exports = __webpack_public_path__ + "img/gpt-ios-step-1.88eb59f1.png";